document.addEventListener('DOMContentLoaded', () => {
  const groups = [...document.querySelectorAll('.desktop-nav .ub-nav-category')];
  const setOpen = (group, open) => {
    group.classList.toggle('is-open', open);
    group.querySelector('a')?.setAttribute('aria-expanded', String(open));
    group.querySelector('[role="menu"]')?.setAttribute('aria-hidden', String(!open));
  };
  const closeAll = () => groups.forEach(group => setOpen(group, false));
  groups.forEach(group => {
    const link = group.querySelector('a');
    link?.addEventListener('click', event => {
      // A second click on the same category retains its native collection link.
      if (group.classList.contains('is-open')) return;
      event.preventDefault();
      closeAll();
      setOpen(group, true);
    });
    group.querySelector('.catalogue-menu-close')?.addEventListener('click', () => {
      closeAll();
      link?.focus({preventScroll:true});
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = groups.find(group => group.classList.contains('is-open'));
    if (!open) return;
    closeAll();
    open.querySelector('a')?.focus({preventScroll:true});
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.desktop-nav')) closeAll();
  });
});
